export default function replaceOutlookTags(html) {
  return html
    .replace(/<outlook-only>/g, "<!--[if mso]>")
    .replace(/<\/outlook-only>/g, "<![endif]-->")
    .replace(/<except-outlook>/g, "<!--[if !mso]>-->")
    .replace(/<\/except-outlook>/g, "<!--<![endif]-->")
    .replace(/&amp;(\w+)=/g, "&$1=") // undo & that are converted to &amp; in links
    .replace(/<outlook-container width="(\d+)">/g, (match, p1) => {
      const width = p1
      return `<!--[if mso]><table><tr><td width="${width}"><![endif]-->`
    })
    .replace(/<\/?mso-snippet>/g, "")
    .replace(
      /<\/outlook-container>/g,
      "<!--[if mso]></td></tr></table><![endif]-->"
    )
}
